import { render, staticRenderFns } from "./IsLoginAndRegistered.vue?vue&type=template&id=f94798e4"
import script from "./IsLoginAndRegistered.vue?vue&type=script&lang=js"
export * from "./IsLoginAndRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme3ComponentsExchangeRate: require('/app/components/Theme3/Components/ExchangeRate.vue').default,Theme3MobilePlayerBalance: require('/app/components/Theme3/Mobile/PlayerBalance.vue').default,Theme3DesktopNavCoinBalance: require('/app/components/Theme3/Desktop/Nav/CoinBalance.vue').default,Theme3DesktopNavProfileDropdown: require('/app/components/Theme3/Desktop/Nav/ProfileDropdown.vue').default,Theme3DesktopLanguageSwitcher: require('/app/components/Theme3/Desktop/LanguageSwitcher.vue').default,Theme3DesktopNavNotificationDropdown: require('/app/components/Theme3/Desktop/Nav/NotificationDropdown.vue').default})
